import { BettyHistoryModuleType } from "UidispatcherApiModule";
const { BettyHistoryModule }: { BettyHistoryModule: BettyHistoryModuleType } =
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore
    await import("uidispatcher_api/UidispatcherApiModule");

export default BettyHistoryModule;
